import { useSessionStorage } from 'usehooks-ts';

export const useAddToolSessionStorage = () => {
  const [newToolIds, setNewToolIds] = useSessionStorage<string[]>('new-tool-ids', []);
  const [isWarrantyExtensionApplied, setIsWarrantyExtensionApplied] = useSessionStorage('is-warranty-extension-applied', false);

  const clearNewTool = () => {
    setNewToolIds([]);
    setIsWarrantyExtensionApplied(false);
  };

  return { newToolIds, setNewToolIds, isWarrantyExtensionApplied, setIsWarrantyExtensionApplied, clearNewTool };
};
